import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { PaymentDto } from '../dtos';

export enum PaymentsActionTypes {
  LoadPayments = '[Payments] LoadPayments',
  LoadPaymentsSuccess = '[Payments] LoadPaymentsSuccess',
  LoadPaymentsError = '[Payments] LoadPaymentsError',
  SelectPayment = '[Payments] SelectCustomerGroup',
}

export const loadPaymentsAction = createAction(PaymentsActionTypes.LoadPayments);
export const loadPaymentsSuccessAction = createAction(PaymentsActionTypes.LoadPaymentsSuccess, props<{ payments: PaymentDto[] }>());
export const loadPaymentsErrorAction = createAction(PaymentsActionTypes.LoadPaymentsError, props<{ failure: AppStateFailure }>());
export const selectPaymentAction = createAction(PaymentsActionTypes.SelectPayment, props<{ paymentId: number }>());
